<div class="contact-page" data-testid="contact-page">
  <div class="page-header">
    <h1 class="page-header__title">Contact Us</h1>
    <p class="page-header__subtitle">
      Questions or an issue with a project? Send us a message and the
      CREtelligent team will follow up.
    </p>
  </div>

  <div class="contact-grid">
    <!-- Form card -->
    <section class="card contact-form-card" data-testid="contact-form-card">
      <h2 class="contact-card__title">Send Us a Message</h2>
      <form [formGroup]="contactUsForm" (ngSubmit)="sendEmail()">
        <div class="contact-form-row">
          <div class="form-field">
            <label class="form-label" for="firstName"
              >First Name<span class="req">*</span></label
            >
            <input
              id="firstName"
              type="text"
              class="input"
              formControlName="firstName"
              data-testid="contact-first-name"
            />
            <div
              *ngIf="
                contactUsForm.controls['firstName']?.invalid &&
                (contactUsForm.controls['firstName'].dirty ||
                  contactUsForm.controls['firstName'].touched) &&
                contactUsForm.controls['firstName'].errors?.['required']
              "
              class="error-message"
            >
              First name is required.
            </div>
          </div>
          <div class="form-field">
            <label class="form-label" for="lastName"
              >Last Name<span class="req">*</span></label
            >
            <input
              id="lastName"
              type="text"
              class="input"
              formControlName="lastName"
              data-testid="contact-last-name"
            />
            <div
              *ngIf="
                contactUsForm.controls['lastName']?.invalid &&
                (contactUsForm.controls['lastName'].dirty ||
                  contactUsForm.controls['lastName'].touched) &&
                contactUsForm.controls['lastName'].errors?.['required']
              "
              class="error-message"
            >
              Last name is required.
            </div>
          </div>
        </div>

        <div class="contact-form-row">
          <div class="form-field">
            <label class="form-label" for="email"
              >Email<span class="req">*</span></label
            >
            <input
              id="email"
              type="text"
              class="input"
              formControlName="email"
              data-testid="contact-email"
              (keydown)="clearEmailValidation()"
            />
            <div
              *ngIf="
                contactUsForm.controls['email']?.invalid &&
                (contactUsForm.controls['email'].dirty ||
                  contactUsForm.controls['email'].touched)
              "
            >
              <div *ngIf="invalidEmail" class="error-message">
                Email is invalid.
              </div>
              <div
                *ngIf="contactUsForm.controls['email'].errors?.['required']"
                class="error-message"
              >
                Email is required.
              </div>
            </div>
          </div>
          <div class="form-field">
            <label class="form-label" for="phone">Phone Number</label>
            <input
              id="phone"
              type="text"
              class="input"
              formControlName="phone"
              data-testid="contact-phone"
            />
          </div>
        </div>

        <div class="form-field">
          <label class="form-label" for="organizationName">Organization</label>
          <input
            id="organizationName"
            type="text"
            class="input"
            formControlName="organizationName"
            data-testid="contact-organization"
          />
        </div>

        <div class="form-field">
          <label class="form-label" for="message"
            >Please describe your reason for contacting<span class="req"
              >*</span
            ></label
          >
          <textarea
            id="message"
            class="input contact-textarea"
            rows="6"
            formControlName="message"
            data-testid="contact-message"
          ></textarea>
          <div
            *ngIf="
              contactUsForm.controls['message']?.invalid &&
              (contactUsForm.controls['message'].dirty ||
                contactUsForm.controls['message'].touched) &&
              contactUsForm.controls['message'].errors?.['required']
            "
            class="error-message"
          >
            A reason is required.
          </div>
        </div>

        <button
          class="btn btn--primary contact-submit"
          type="submit"
          [disabled]="isSubmitting"
          data-testid="contact-submit"
        >
          Submit
        </button>
      </form>
    </section>

    <!-- Contact info / operation hours card -->
    <section class="card contact-info-card" data-testid="contact-info-card">
      <h2 class="contact-card__title">Get in Touch</h2>
      <ul class="contact-info-list">
        <li>
          <span class="material-icons" aria-hidden="true">location_on</span>
          <p>11344 Coloma Road, Gold River, CA 95670.</p>
        </li>
        <li>
          <span class="material-icons" aria-hidden="true">call</span>
          <p>(866) 358-7099</p>
        </li>
      </ul>

      <h3 class="contact-hours__title">
        <span class="material-icons" aria-hidden="true">access_alarm</span>
        Operation Hours
      </h3>
      <ul class="contact-hours__list">
        <li><span>Monday</span><span>6:00 AM - 5:00 PM / PST</span></li>
        <li><span>Tuesday</span><span>6:00 AM - 5:00 PM / PST</span></li>
        <li><span>Wednesday</span><span>6:00 AM - 5:00 PM / PST</span></li>
        <li><span>Thursday</span><span>6:00 AM - 5:00 PM / PST</span></li>
        <li><span>Friday</span><span>6:00 AM - 5:00 PM / PST</span></li>
      </ul>
    </section>
  </div>
</div>
